import React from "react";



export default ({ storefrontAccessToken, collectionId }) => (
<div></div>
)

